import InvestmentCardsSection from './InvestmentCardsSection';

export default InvestmentCardsSection;
